<div #dropArea class="drag-drop-area">
  <ng-content></ng-content>
</div>
